import React, { useEffect } from "react";
import { Layout } from "@components/layout/Layout";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Pwa_macOS.css"; // підключаємо свої стилі (створи файл)
import arrowLeft from "@assets/images/main/Vector11.svg";
import arrowRight from "@assets/images/main/Vector10.svg";

export const Pwa_macOS = () => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("main-page");
    return () => {
      document.body.classList?.remove("main-page");
    };
  }, []);

  return (
    <Layout>
      <div className="basic-main">
        <div className="pwa-macos-section section">
          <div className="container">
            <div className="pwa-section tabs">
              <div className="title-pwa-macos">
                <h1>HOW TO INSTALL THE APP ON macOS?</h1>
                <p>Cronika app web version</p>
              </div>

              <ul className="macos-tabs-menu">
                <li className="active basic-button transparent-button chrome" data-tab="#google-chrome">
                  <img src={require("@assets/images/main/chrome-icon.svg").default} alt="" />
                  Google Chrome
                </li>
                <li className="basic-button transparent-button safari" data-tab="#safari">
                <img src={require("@assets/images/main/safari-icon.svg").default} alt="" />
                  Safari
                </li>
              </ul>

              {/* Google Chrome Slider */}
              <div className="tab" id="google-chrome">
                <Swiper
                  modules={[Pagination, Navigation]}
                  pagination={{ el: ".chrome-pagination", clickable: true }}
                  navigation={{
                    nextEl: ".chrome-next",
                    prevEl: ".chrome-prev"
                  }}
                  className="pwa-macos-slider"
                >
                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-chrome-img01.png")} alt="img" />
                    </figure>
                    <span className="step">
                      <b>
                      <svg
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style={{ transform: "scale(1, -1)" }}
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.313 3.42764C11.4987 3.2521 11.7445 3.1543 12 3.1543C12.2555 3.1543 12.5013 3.2521 12.687 3.42764L15.687 6.26164C15.8798 6.44384 15.9923 6.69518 15.9998 6.96036C16.0074 7.22553 15.9092 7.48283 15.727 7.67564C15.5448 7.86845 15.2935 7.98099 15.0283 7.98849C14.7631 7.99599 14.5058 7.89784 14.313 7.71564L13 6.47564V13.1556C13 13.4209 12.8946 13.6752 12.7071 13.8627C12.5196 14.0503 12.2652 14.1556 12 14.1556C11.7348 14.1556 11.4804 14.0503 11.2929 13.8627C11.1054 13.6752 11 13.4209 11 13.1556V6.47464L9.687 7.71464C9.59153 7.80486 9.47922 7.87539 9.35649 7.9222C9.23377 7.96902 9.10302 7.9912 8.97172 7.98749C8.84041 7.98377 8.71113 7.95423 8.59124 7.90056C8.47136 7.84688 8.36322 7.77011 8.273 7.67464C8.0908 7.48183 7.99265 7.22453 8.00015 6.95936C8.00765 6.69418 8.12019 6.44284 8.313 6.26064L11.313 3.42764ZM15.667 10.6546C15.667 10.3894 15.7724 10.1351 15.9599 9.94753C16.1474 9.76 16.4018 9.65464 16.667 9.65464H18C18.5304 9.65464 19.0391 9.86535 19.4142 10.2404C19.7893 10.6155 20 11.1242 20 11.6546V19.6546C20 20.1851 19.7893 20.6938 19.4142 21.0689C19.0391 21.4439 18.5304 21.6546 18 21.6546H6C5.46957 21.6546 4.96086 21.4439 4.58579 21.0689C4.21071 20.6938 4 20.1851 4 19.6546V11.6546C4 11.1242 4.21071 10.6155 4.58579 10.2404C4.96086 9.86535 5.46957 9.65464 6 9.65464H7.333C7.59822 9.65464 7.85257 9.76 8.04011 9.94753C8.22764 10.1351 8.333 10.3894 8.333 10.6546C8.333 10.9199 8.22764 11.1742 8.04011 11.3617C7.85257 11.5493 7.59822 11.6546 7.333 11.6546H6V19.6546H18V11.6546H16.667C16.4018 11.6546 16.1474 11.5493 15.9599 11.3617C15.7724 11.1742 15.667 10.9199 15.667 10.6546Z"
    fill="#F9B035"
  />
</svg>
Step 1</b>
                      <small>Click on the icon in the address bar</small>
                    </span>
                  </SwiperSlide>

                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-chrome-img02.png")} alt="img" />
                    </figure>
                    <span className="step">
                      <b>
                      <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L11.5607 15.8536C10.9749 16.4393 10.0251 16.4393 9.43934 15.8536L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929L10.5 14.0858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z"
    fill="#F9B035"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
    fill="#F9B035"
  />
</svg> 
                        Step 2</b>
                      <small>To confirm the installation, click the "Install" button</small>
                    </span>
                  </SwiperSlide>

                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-chrome-img03.png")} alt="img" />
                    </figure>
                    <span className="step">
                      <b>
                      <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 2C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2H7ZM20 12V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V15H5.441L6.936 12.571C7.04342 12.3965 7.19374 12.2524 7.37264 12.1524C7.55155 12.0525 7.75307 12 7.958 12H11.36L13.693 6.945C13.7863 6.74234 13.9343 6.56972 14.1204 6.44653C14.3064 6.32333 14.5231 6.25443 14.7461 6.24758C14.9691 6.24072 15.1896 6.29618 15.3828 6.40772C15.5761 6.51926 15.7344 6.68246 15.84 6.879L18.597 12H20ZM4 17H5.888C6.09293 17 6.29445 16.9475 6.47335 16.8476C6.65226 16.7476 6.80258 16.6035 6.91 16.429L8.405 14H11.872C12.1013 14.0001 12.3258 13.9345 12.519 13.811C12.7122 13.6875 12.8659 13.5112 12.962 13.303L14.838 9.237L17.063 13.369C17.1657 13.5597 17.3181 13.719 17.504 13.8301C17.6899 13.9412 17.9024 13.9999 18.119 14H20V17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17Z"
    fill="#F9B035"
  />
</svg>
                        Step 3</b>
                      <small>Start Trading</small>
                    </span>
                  </SwiperSlide>
                </Swiper>

                <div className="custom-controls">
                  <div className="chrome-prev safari-circle"><img src={arrowLeft} className="chorme-safari-img chorme-safari-img-left" alt="img" /></div>
                  <div className="chrome-pagination"></div>
                  <div className="chrome-next safari-circle"><img src={arrowRight} className="chorme-safari-img" alt="img" /></div>
                </div>
              </div>

              {/* Safari Slider */}
              <div className="tab" id="safari">
                <Swiper
                  modules={[Pagination, Navigation]}
                  pagination={{ el: ".safari-pagination", clickable: true }}
                  navigation={{
                    nextEl: ".safari-next",
                    prevEl: ".safari-prev"
                  }}
                  className="pwa-macos-slider"
                >
                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-safari-img01.png")} alt="img" />
                    </figure>
                    <span className="step">
                    

                      <b>
                      <svg
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style={{ transform: "scale(1, -1)" }}
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.313 3.42764C11.4987 3.2521 11.7445 3.1543 12 3.1543C12.2555 3.1543 12.5013 3.2521 12.687 3.42764L15.687 6.26164C15.8798 6.44384 15.9923 6.69518 15.9998 6.96036C16.0074 7.22553 15.9092 7.48283 15.727 7.67564C15.5448 7.86845 15.2935 7.98099 15.0283 7.98849C14.7631 7.99599 14.5058 7.89784 14.313 7.71564L13 6.47564V13.1556C13 13.4209 12.8946 13.6752 12.7071 13.8627C12.5196 14.0503 12.2652 14.1556 12 14.1556C11.7348 14.1556 11.4804 14.0503 11.2929 13.8627C11.1054 13.6752 11 13.4209 11 13.1556V6.47464L9.687 7.71464C9.59153 7.80486 9.47922 7.87539 9.35649 7.9222C9.23377 7.96902 9.10302 7.9912 8.97172 7.98749C8.84041 7.98377 8.71113 7.95423 8.59124 7.90056C8.47136 7.84688 8.36322 7.77011 8.273 7.67464C8.0908 7.48183 7.99265 7.22453 8.00015 6.95936C8.00765 6.69418 8.12019 6.44284 8.313 6.26064L11.313 3.42764ZM15.667 10.6546C15.667 10.3894 15.7724 10.1351 15.9599 9.94753C16.1474 9.76 16.4018 9.65464 16.667 9.65464H18C18.5304 9.65464 19.0391 9.86535 19.4142 10.2404C19.7893 10.6155 20 11.1242 20 11.6546V19.6546C20 20.1851 19.7893 20.6938 19.4142 21.0689C19.0391 21.4439 18.5304 21.6546 18 21.6546H6C5.46957 21.6546 4.96086 21.4439 4.58579 21.0689C4.21071 20.6938 4 20.1851 4 19.6546V11.6546C4 11.1242 4.21071 10.6155 4.58579 10.2404C4.96086 9.86535 5.46957 9.65464 6 9.65464H7.333C7.59822 9.65464 7.85257 9.76 8.04011 9.94753C8.22764 10.1351 8.333 10.3894 8.333 10.6546C8.333 10.9199 8.22764 11.1742 8.04011 11.3617C7.85257 11.5493 7.59822 11.6546 7.333 11.6546H6V19.6546H18V11.6546H16.667C16.4018 11.6546 16.1474 11.5493 15.9599 11.3617C15.7724 11.1742 15.667 10.9199 15.667 10.6546Z"
    fill="#F9B035"
  />
</svg>
Step 1</b>
                      <small>Click "Share"</small>
                    </span>
                  </SwiperSlide>

                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-safari-img02.png")} alt="img" />
                    </figure>
                    <span className="step">
                      <b>
                      <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L11.5607 15.8536C10.9749 16.4393 10.0251 16.4393 9.43934 15.8536L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929L10.5 14.0858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z"
    fill="#F9B035"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
    fill="#F9B035"
  />
</svg>
                        Step 2</b>
                      <small>Click "Add to Dock"</small>
                    </span>
                  </SwiperSlide>

                  <SwiperSlide>
                    <figure>
                      <img src={require("@assets/images/main/macos-safari-img03.png")} alt="img" />
                    </figure>
                    <span className="step">
                      <b>
                      <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 2C5.67392 2 4.40215 2.52678 3.46447 3.46447C2.52678 4.40215 2 5.67392 2 7V17C2 18.3261 2.52678 19.5979 3.46447 20.5355C4.40215 21.4732 5.67392 22 7 22H17C18.3261 22 19.5979 21.4732 20.5355 20.5355C21.4732 19.5979 22 18.3261 22 17V7C22 5.67392 21.4732 4.40215 20.5355 3.46447C19.5979 2.52678 18.3261 2 17 2H7ZM20 12V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V15H5.441L6.936 12.571C7.04342 12.3965 7.19374 12.2524 7.37264 12.1524C7.55155 12.0525 7.75307 12 7.958 12H11.36L13.693 6.945C13.7863 6.74234 13.9343 6.56972 14.1204 6.44653C14.3064 6.32333 14.5231 6.25443 14.7461 6.24758C14.9691 6.24072 15.1896 6.29618 15.3828 6.40772C15.5761 6.51926 15.7344 6.68246 15.84 6.879L18.597 12H20ZM4 17H5.888C6.09293 17 6.29445 16.9475 6.47335 16.8476C6.65226 16.7476 6.80258 16.6035 6.91 16.429L8.405 14H11.872C12.1013 14.0001 12.3258 13.9345 12.519 13.811C12.7122 13.6875 12.8659 13.5112 12.962 13.303L14.838 9.237L17.063 13.369C17.1657 13.5597 17.3181 13.719 17.504 13.8301C17.6899 13.9412 17.9024 13.9999 18.119 14H20V17C20 17.7956 19.6839 18.5587 19.1213 19.1213C18.5587 19.6839 17.7956 20 17 20H7C6.20435 20 5.44129 19.6839 4.87868 19.1213C4.31607 18.5587 4 17.7956 4 17Z"
    fill="#F9B035"
  />
</svg>
                        Step 3</b>
                      <small>Start Trading</small>
                    </span>
                  </SwiperSlide>
                </Swiper>

                <div className="custom-controls">
                  <div className="safari-circle safari-prev"><img src={arrowLeft} className="chorme-safari-img chorme-safari-img-left" alt="img" /></div>
                  <div className="safari-pagination"></div>
                  <div className="safari-circle safari-next"><img src={arrowRight} className="chorme-safari-img" alt="img" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a className="scroll-btn" href="#wrapper"></a>
    </Layout>
  );
};

export default Pwa_macOS;
